// extracted by mini-css-extract-plugin
export default {"container":"styles_container__JThyo","checkmark":"styles_checkmark__mFfpO","delete-icon":"styles_delete-icon__d4ncl"};